import { API, DOMAIN } from '@autopass-web/domain';
import HttpClient from '../http-client';

class PicknChargeHttpClient extends HttpClient {
  constructor(props: any) {
    super(props);
    this.apiConfig = DOMAIN.API_URL[API.PICKNCHARGE];
    this.httpClient = this.createHttpClient({
      headers: this.apiConfig.headers,
      baseUrl: this.apiConfig.baseUrl,
    });

    this.httpClient.interceptors.request.use((value: any) =>
      this.interceptRequest(value),
    );
    this.httpClient.interceptors.response.use(
      (value: any) => this.interceptResponseResult(value),
      (error: any) => this.interceptResponseError(error, this.httpClient),
    );
  }

  getEvses = ({
    evstationId,
    evseId,
  }: {
    evstationId: string;
    evseId: string;
  }) => this.get(`/stores/${evstationId}/evses/${evseId}`);

  initChargingRecord = (id: string) =>
    this.post(`/charging_records/init`, { EvseID: id });

  confirmChargingRecord = (id: string) =>
    this.post(`/charging_records/${id}/confirm`);

  getChargingRecord = (transactionId: string) =>
    this.get(`/charging_records/${transactionId}`);

  updateChargingRecord = ({ id, email }: { id: string; email: string }) =>
    this.post(`/charging_records/${id}`, { Email: email });
}

export default PicknChargeHttpClient;
